// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2TDOT","select":"Header_select__34T46","clinic":"Header_clinic__1e8DP"};